import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import { FiDollarSign, FiFileText, FiBarChart2 } from 'react-icons/fi';
import { fetchPoliciesTrips, fetchPoliciesActivities } from '../store/actions/dataActions';
import 'bootstrap/dist/css/bootstrap.css';
import './DashboardPages.css';

const Premium = () => {
    const dispatch = useDispatch();
    const { policies } = useSelector(state => state.data);

    useEffect(() => {
        dispatch(fetchPoliciesTrips());
        dispatch(fetchPoliciesActivities());
    }, [dispatch]);

    // Calculs des statistiques
    const calculateStats = () => {
        const allPolicies = [
            ...(policies.trips.data || []),
            ...(policies.activities.data || []),
        ];

        const totalPremium = allPolicies.reduce((sum, policy) => {
            return sum + (policy.premium || policy.tsca_amount || 0);
        }, 0);

        const numberOfPolicies = allPolicies.length;

        const premiums = allPolicies.map(p => p.premium || p.tsca_amount || 0);
        const avgPremium = premiums.length > 0 ? totalPremium / premiums.length : 0;
        const minPremium = premiums.length > 0 ? Math.min(...premiums) : 0;
        const maxPremium = premiums.length > 0 ? Math.max(...premiums) : 0;

        return {
            totalPremium: totalPremium.toFixed(2),
            numberOfPolicies,
            avgPremium: avgPremium.toFixed(2),
            minPremium: minPremium.toFixed(2),
            maxPremium: maxPremium.toFixed(2),
        };
    };

    const stats = calculateStats();
    const loading = policies.trips.loading || policies.activities.loading;

    return (
        <div className="dashboard-page">
            <h2 className="page-header">Premium</h2>
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="stat-card stat-success">
                        <Card.Body>
                            <div className="stat-content">
                                <FiDollarSign className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : `${stats.totalPremium} €`}
                                    </div>
                                    <div className="stat-label">Total amount of premium</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-success">
                        <Card.Body>
                            <div className="stat-content">
                                <FiFileText className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : stats.numberOfPolicies}
                                    </div>
                                    <div className="stat-label">Number of policies</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-success">
                        <Card.Body>
                            <div className="stat-content">
                                <FiBarChart2 className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : `${stats.avgPremium} €`}
                                    </div>
                                    <div className="stat-label">Average premium</div>
                                    <div className="stat-subtext">
                                        Min: {stats.minPremium} € | Max: {stats.maxPremium} €
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Premium;

